import React from 'react';

const ProgressRing = ({ 
    value, 
    max = 100, 
    size = 120, 
    strokeWidth = 10,
    color = '#6366f1',
    backgroundColor = '#e5e7eb',
    label,
    sublabel,
    showPercentage = true
}) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = radius * 2 * Math.PI;
    const percentage = Math.min(100, Math.max(0, (value / max) * 100));
    const offset = circumference - (percentage / 100) * circumference;

    const getColor = () => {
        if (typeof color === 'string') return color;
        // Gradient based on percentage
        if (percentage >= 80) return '#22c55e'; // green
        if (percentage >= 60) return '#6366f1'; // primary
        if (percentage >= 40) return '#f59e0b'; // amber
        return '#ef4444'; // red
    };

    return (
        <div className="flex flex-col items-center">
            <div className="relative" style={{ width: size, height: size }}>
                <svg width={size} height={size} className="transform -rotate-90">
                    {/* Background circle */}
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        fill="none"
                        stroke={backgroundColor}
                        strokeWidth={strokeWidth}
                    />
                    {/* Progress circle */}
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        fill="none"
                        stroke={getColor()}
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeDasharray={circumference}
                        strokeDashoffset={offset}
                        className="transition-all duration-500 ease-out"
                    />
                </svg>
                {/* Center content */}
                <div className="absolute inset-0 flex flex-col items-center justify-center">
                    {showPercentage && (
                        <span className="text-2xl font-bold text-gray-900">
                            {Math.round(percentage)}%
                        </span>
                    )}
                    {label && (
                        <span className="text-xs text-gray-500 mt-1">{label}</span>
                    )}
                </div>
            </div>
            {sublabel && (
                <p className="text-sm text-gray-600 mt-2 text-center">{sublabel}</p>
            )}
        </div>
    );
};

export default ProgressRing;
